import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { space, SpaceProps } from 'styled-system';

type CarouselTheme = {
  loadingColor?: string;
};

type SkeletonProps = SpaceProps & {
  height?: number | string;
  width?: number | string;
  circle?: boolean;
  rounded?: boolean;
  carouselTheme?: CarouselTheme;
};

const Skeleton = (props: SkeletonProps): JSX.Element => {
  const { carouselTheme } = props;

  return (
    <div>
      <StyledSkeleton loadingColor={carouselTheme?.loadingColor} {...props}>
        &zwnj;
      </StyledSkeleton>
    </div>
  );
};

Skeleton.defaultProps = {
  width: null,
  height: null,
  circle: false,
};

export default Skeleton;

const loadingOpacityProgression = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`;

const animations = (): ReturnType<typeof css> => css`
  animation: ${loadingOpacityProgression} 1s linear infinite;
`;

type StyledSkeletonProps = SkeletonProps & {
  loadingColor?: string;
  theme?: {
    colors: {
      grey: Record<number, string>;
    };
  };
};

export const StyledSkeleton = styled.div<StyledSkeletonProps>`
  ${space}
  ${animations}
  background-color: ${({ theme, loadingColor }) => loadingColor ?? theme.colors.grey[95]};
  background-size: 200px 100%;
  background-repeat: no-repeat;
  display: inline-block;
  line-height: 1;
  width: 100%;
  height: 100%;

  width: ${({ width }) => width && `${String(width)}px`};
  height: ${({ height }) => height && `${String(height)}px`};

  border-radius: ${({ width, height, circle, rounded }) => {
    if (width && height && circle) {
      return `50%`;
    }
    if (rounded) {
      return `30px`;
    }
    return `10px`;
  }};
`;
